import { render, staticRenderFns } from "./QrCodeImage.vue?vue&type=template&id=72d9ee1f&scoped=true&"
import script from "./QrCodeImage.vue?vue&type=script&lang=js&"
export * from "./QrCodeImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d9ee1f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
